(function () {
    "use strict";

    // @ngInject
    function ServiceAutoCompleteControllerCtor($scope, $injector, WorkspaceFilesManager, $q, AnalyticsService, DeviceService, $filter, _) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ServiceAutoCompleteController';

        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.$q = $q;
        this.AnalyticsService = AnalyticsService;
        this.DeviceService = DeviceService;
        this.$filter = $filter;

        this.debouncedLoadItems = _.debounce(this.loadItems, 500);
    }

    var ServiceAutoCompleteController = Class(Controllers.BaseController, {
        constructor: ServiceAutoCompleteControllerCtor,

        $onChanges: function $onChanges() {
            this.loadingItems = true;
            this.debouncedLoadItems();
        },

        onClearSearchClicked: function onClearSearchClicked() {
            this.searchTerm = null;
            this.loadItems();
        },

        onCreateItemClicked: function onCreateItemClicked() {
            if (this.DeviceService.device.isMobileSize) {
                this.onItemCreated({name: this.searchTerm});
            }

            this.close();
        },

        loadItems: function _loadItems() {

            var promises = [];
            promises.push(this.WorkspaceFilesManager.listItems(this.searchTerm));

            if (!this.searchTerm) {
                promises.push(this.WorkspaceFilesManager.getFrequentItems());
            }

            this.searchFiltered = !!this.searchTerm;

            this.$q.all(promises).then(function(responses) {
                var itemsListResp = responses[0];
                this.packages = this.$filter('orderBy')(itemsListResp.data.packages, 'name');
                this.services = itemsListResp.data.services;
                this.frequentItems = (responses[1] && responses[1].data) || [];

                if (this.searchFiltered) {
                    this.filteredItems = this.services.concat(this.packages);
                }

                this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.services_auto_complete_loaded, {
                    filtered: this.searchFiltered,
                    frequent: this.frequentItems.length,
                    services: this.services.length,
                    packages: this.packages.length
                });
            }.bind(this)).finally(function final() {
                this.loadingItems = false;
            }.bind(this));
        },

        itemSelected: function itemSelected(item) {
            this.onItemSelected(item);
            this.close();
        }
    });

    Components.ServiceAutoComplete = {
        bindings: {
            searchTerm: '<',
            isInPackage: '<',
            close: '&',
            onItemSelected: '&',
            onItemCreated: '&'
        },
        controller: ServiceAutoCompleteController,
        controllerAs: 'serviceAutoCompleteVm',
        name: 'hbServiceAutoComplete',
        templateUrl: 'angular/app/modules/core/features/workspace_file/services/auto_complete/service_auto_complete_directive_template.html'
    };

}());